// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1__DB","cls2":"Cta-cls2__Dz Cta-cls1__DB"};